
import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface UnsupportedLanguageDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const UnsupportedLanguageDialog = ({ open, onOpenChange }: UnsupportedLanguageDialogProps) => {
  console.log('🎭 UnsupportedLanguageDialog render - open prop:', open);
  console.log('🎭 UnsupportedLanguageDialog render - component is rendering');
  
  return (
    <>
      {console.log('🎭 UnsupportedLanguageDialog - About to render AlertDialog with open =', open)}
      <AlertDialog open={open} onOpenChange={() => {}}>
        <AlertDialogContent className="max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle>Language Not Supported</AlertDialogTitle>
            <AlertDialogDescription className="space-y-4">
              <p>
                Clara.care is not configured to work with your current browser language settings.
              </p>
              <p>
                The system works with the following languages and their variants:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm">
                <li>Spanish (es, es-ES, es-MX, es-AR, etc.)</li>
                <li>English (en, en-US, en-GB, en-CA, etc.)</li>
                <li>Portuguese (pt, pt-BR, pt-PT, etc.)</li>
              </ul>
              <p className="text-sm">
                The system automatically detects your browser's preferred languages and their variants.
              </p>
            </AlertDialogDescription>
          </AlertDialogHeader>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
